import { mapGetters} from 'vuex';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import { changeSkin } from '@/utils/common.js';

export default {
  components: {
    ProcessNavigation
  },
  data() {
    return {
      count: 0,
      processList: ['选择用户类型', '签订用户服务协议', '填写注册信息', '注册成功']
    };
  },
  created() {
  },
  mounted() {
    if (this.count === 0 && document.documentElement.scrollTop) {
      document.documentElement.scrollTop = 0;
      this.count++;
    }
  },
  computed: {
    ...mapGetters([
      'userType'
    ])
  },
  methods: {
    changeSkin,
    toLogin() {
      this.$router.push('/signin');
    }
  }
};
